import { Filter, filterInstances, Module, Processor, } from '@nu-art/ts-common';
import { ThunderDispatcher } from '@nu-art/thunderstorm-frontend/index';
export const dispatch_globalSearch = new Processor('__searchFilterMapper');
export const dispatch_globalSearchResults = new Processor('__getSearchResults');
export const dispatch_searchResultSelected = new ThunderDispatcher('__onSearchResultSelected');
class ModuleFE_SearchV2_Class extends Module {
    async query(toSearchIn, searchTerm) {
        const searchResults = dispatch_globalSearch.processModules((module) => {
            const searchItem = toSearchIn.find(searchItem => searchItem.module === module);
            if (!searchItem)
                return;
            const filter = new Filter(module.__searchFilterMapper);
            filter.setRegexp(false);
            filter.prepareFilter(searchTerm);
            let items;
            if ('filter' in searchItem && searchItem.filter)
                items = module.cache.filter(searchItem.filter);
            else
                items = module.cache.all();
            return {
                type: searchItem.type,
                results: items.filter(filter.filterImpl)
            };
        });
        const searchResults2 = dispatch_globalSearchResults.processModules((_module) => {
            const module = _module;
            const searchItem = toSearchIn.find(searchItem => searchItem.module === module);
            if (!searchItem)
                return;
            const results = module.__getSearchResults(searchTerm);
            return {
                type: searchItem.type,
                results: results
            };
        });
        return filterInstances([...searchResults, ...searchResults2]);
    }
}
export const ModuleFE_SearchV2 = new ModuleFE_SearchV2_Class();
//# sourceMappingURL=ModuleFE_SearchV2.js.map